import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PdfService } from '../@shared/services/pdf.service';
import jsPDF from 'jspdf';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ToastrService } from 'ngx-toastr';
// import { MyCourseListComponent } from '../@modules/lms/lms-management/management-user/my-courses/my-course-list/my-course-list.component';

@Component({
  standalone: false,
  selector: 'app-task-order-pdf',
  templateUrl: './task-order-pdf.component.html',
  styleUrls: ['./task-order-pdf.component.scss']
})
export class TaskOrderPdfComponent {
  @ViewChild(TemplateRef) dialogTemplate: TemplateRef<any>;
  Login_user_id: any = localStorage.getItem('loginUserDetails');
  loginUserId: any = JSON.parse(this.Login_user_id).employee_id;
  loginUserName: any = JSON.parse(this.Login_user_id).first_name;
  Certificate_LogoType: any;
  certifies: string;

  constructor(
    private toast: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private pdfService: PdfService
  ){
    // if(data.result==100){
    //   this.certifies="has successfully completed the"

    // }
    // else if(data.current_attempt_count==data.Max_attempt_count){
    //   this.certifies="has participated in "

    // }

  }
  pdfGenerate() {
    this.Certificate_LogoType = 'complete';
    const dashboard = document.getElementById('dashboard');
    if (!dashboard) {
      console.error('Dashboard element not found');
      return;
    }

    // Use PdfService with a custom pdfFactory to match previous behavior (page sized to element)
    this.pdfService.downloadElementAsPdf(dashboard, `${this.loginUserName} certificate`, undefined, {
      pdfFactory: (canvas) => new (jsPDF as any)(canvas.width > canvas.height ? 'landscape' : 'portrait', 'px', [canvas.width, canvas.height]),
      beforeSave: (pdf: any, canvas: HTMLCanvasElement) => {
        try {
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();

          const header = 'This is header';
          const headerHeight = 20;
          pdf.setFontSize(12);
          pdf.setTextColor(0, 0, 0);
          pdf.text(header, pdfWidth / 2, headerHeight, { align: 'center' });

          const footer = 'This is footer';
          const footerHeight = 10;
          pdf.setFontSize(10);
          pdf.setTextColor(0, 0, 0);
          pdf.text(footer, pdfWidth / 2, pdfHeight - footerHeight, { align: 'center' });

          // the service already added the image(s) covering the page; headers/footers are drawn above.
          this.toast.info('Please Attach Offer Latter with Mail..');
        } catch (e) {
          // ignore
        }
      }
    });
  }

}
